import "./style.css";
import Experience from "./Experience/Experience.js";

// The 3D experience runs on all devices now, including mobile / touch screens.
// (The old desktop-only gate that showed a "visit on desktop" message has been
// removed; touch navigation + responsive UI are handled in Navigation/CSS.)
window.experience = new Experience({
  webglElement: document.querySelector("#webgl"),
  cssArcadeMachine: document.querySelector("#cssArcadeMachine"),
  cssLeftMonitor: document.querySelector("#cssLeftMonitor"),
  cssRightMonitor: document.querySelector("#cssRightMonitor"),
});
